import 'angular:locale/data:en';
import 'angular:locale/data:sl';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
